export default "__VITE_ASSET__DMjqeJ1s__"